<tc-master-operator-single
  [singleId]="widgetInstanceKey"
  [settings]="settings"
  (configured)="onConfigureConnection($event)"
></tc-master-operator-single>
